/**
 * OnlineBadge — small pill showing "Online now" (green dot) or "Away" (grey dot).
 * Used on hobby farmer cards/profiles.
 */
export default function OnlineBadge({ isOnline, size = "sm", className = "" }) {
  const dot = size === "lg" ? "w-2.5 h-2.5" : "w-2 h-2";
  return (
    <span
      data-testid={isOnline ? "online-badge-on" : "online-badge-off"}
      title={isOnline ? "Online now" : "Currently away"}
      className={
        "inline-flex items-center gap-1.5 text-xs font-sans " +
        (isOnline ? "text-emerald-700" : "text-stone-500") +
        " " +
        className
      }
    >
      <span
        className={
          `${dot} rounded-full ` +
          (isOnline
            ? "bg-emerald-600 shadow-[0_0_0_3px_rgba(5,150,105,0.18)] animate-pulse"
            : "bg-stone-400")
        }
      />
      {isOnline ? "Online now" : "Away"}
    </span>
  );
}
